import React from 'react';
import VenuesForm from './VenuesForm';

const NewVenuePage = () => {
    return <VenuesForm formType="create" />;
};

export default NewVenuePage;

